const setOdigeoRequireJs = () => {
    Odigeo.require = window.require;
    Odigeo.define = window.define;
};

const setOdigeoRequireJsProxy = () => {
    const requireQueue = [];
    const defineQueue = [];

    Odigeo.require = (...args) => {
        requireQueue.push(args);
    };
    Odigeo.define = (...args) => {
        defineQueue.push(args);
    };

    Odigeo.requireJsCb = () => {
        for (const defineArgs of defineQueue) window.define(...defineArgs);
        for (const requireArgs of requireQueue) window.require(...requireArgs);

        setOdigeoRequireJs();
    };
};

if (window.require_js_config) {
    setOdigeoRequireJs();
} else {
    setOdigeoRequireJsProxy();
}
